import React, { useEffect, useState } from "react"
import { Link, useSearchParams } from "react-router-dom"
import { getAPIBaseURL } from "../services/helpers"
import { getData } from "../services/request"

const statusFilters = [
  { key: "ALL", label: "All" },
  { key: "PENDING", label: "Pending" },
  { key: "PRICED", label: "Priced" },
  { key: "PAID", label: "Paid" },
  { key: "PAYMENT_CONFIRMED", label: "Payment confirmed" },
  { key: "DELIVERED", label: "Delivered" },
  { key: "RECEIVED", label: "Received" },
  { key: "CANCELLED", label: "Cancelled" }
]

const HospitalRequestsList = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const [requests, setRequests] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState("")
  const [status, setStatus] = useState(searchParams.get('status') || 'ALL')

  const fetchRequests = async () => {
    setLoading(true)
    setError("")
    const url = `${getAPIBaseURL()}/v1/posts`
    const headers = {}
    const params = status && status !== 'ALL' ? { status } : {}
    const res = await getData(url, headers, params)
    setLoading(false)
    if(res.error == ""){
      if(res.result.status === 200){
        setRequests(res.result.data?.data || [])
      }else{
        setError(res.result.data?.message || 'Could not load requests')
      }
    }else{
      setError(res.result?.data?.message || 'Network error')
    }
  }

  useEffect(()=>{ fetchRequests() }, [status])

  const formatDate = (iso) => {
    try { return new Date(iso).toLocaleString() } catch(e){ return iso }
  }

  const setFilter = (value) => {
    setStatus(value)
    const next = new URLSearchParams(searchParams)
    if(value && value !== 'ALL'){ next.set('status', value) } else { next.delete('status') }
    setSearchParams(next)
  }

  return (
    <div className="mx-auto max-w-6xl px-3 sm:px-0">
      <div className="mb-4 flex flex-col gap-3 sm:mb-6 sm:flex-row sm:items-center sm:justify-between">
        <h2 className="text-lg font-semibold text-gray-900 sm:text-xl">Patient Requests</h2>
        <div className="flex flex-wrap items-center gap-2">
          {statusFilters.map((f) => (
            <button key={f.key} onClick={()=>setFilter(f.key)} className={`rounded-full border px-3 py-1.5 text-xs font-medium transition-colors sm:text-sm ${status===f.key ? 'border-black bg-black text-white' : 'border-gray-200 bg-white text-gray-700 hover:bg-gray-50'}`}>{f.label}</button>
          ))}
        </div>
      </div>
      <div className="rounded-lg bg-white shadow-sm border border-gray-200">
        {loading ? (
          <div className="p-4 sm:p-6 text-sm text-gray-500">Loading...</div>
        ) : error ? (
          <div className="p-4 sm:p-6 text-sm text-red-600">{error}</div>
        ) : requests.length === 0 ? (
          <div className="p-4 sm:p-6 text-sm text-gray-500">No requests found</div>
        ) : (
          <ul className="divide-y divide-gray-200">
            {requests.map((req)=> (
              <li key={req._id} className="p-4 sm:p-5">
                <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between sm:gap-4">
                  <div className="min-w-0 flex-1">
                    <div className="mb-1 flex flex-wrap items-center gap-2">
                      <span className="font-mono text-[11px] text-gray-500 break-all">
                        {req.requestId || req._id}
                      </span>
                      <span className={`rounded-full px-2.5 py-1 text-xs font-semibold ${
                        req.status === 'PAID' ? 'bg-green-100 text-green-700' :
                        req.status === 'DELIVERED' ? 'bg-blue-100 text-blue-700' :
                        req.status === 'RECEIVED' ? 'bg-purple-100 text-purple-700' :
                        req.status === 'PRICED' ? 'bg-yellow-100 text-yellow-700' :
                        req.status === 'CANCELLED' ? 'bg-red-100 text-red-700' :
                        'bg-gray-100 text-gray-700'
                      }`}>
                        {req.status}
                      </span>
                    </div>
                    <p className="mt-1 line-clamp-3 text-sm text-gray-700">{req.message}</p>
                    <p className="mt-1 text-xs text-gray-400">{formatDate(req.createdAt)}</p>
                  </div>
                  <div className="flex w-full flex-wrap gap-2 sm:w-auto sm:flex-nowrap sm:shrink-0">
                    <Link to={`/hospital/requests/${req._id}`} className="w-full sm:w-auto rounded-lg border border-gray-200 px-3 py-2 text-xs font-medium text-gray-700 hover:bg-gray-50 text-center">Open</Link>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  )
}

export default HospitalRequestsList


